import React, { useState, createContext } from 'react'
import PropTypes from 'prop-types'
import { TABS } from '../constants/display'
import { RENTER_CLIENT_TYPE } from '../constants/buyerSettings'

export interface AppContextValueType {
  thumbDirection?: string | null
  includeRental: boolean
  focusedSettingsField: string
  [key: string]: any
}

export const AppContext = createContext<AppContextValueType>({
  thumbDirection: null,
  includeRental: false,
  focusedSettingsField: '',
  setActiveTab: (tab: string) => {},
})

export const AppContextProvider = ({
  address,
  listingPrice,
  widgetMode,
  devMode,
  clientAuthToken,
  customerPublicKey,
  customerProfileId,
  children,
}) => {
  const [marketTempSliderPrice, setMarketTempSliderPrice] = useState(null)
  const [appreciationSliderPercent, setAppreciationSliderPercent] =
    useState(null)
  const [thumbDirection, setThumbDirection] = useState(null)
  const [includeRental, setIncludeRental] = useState(false)
  const [focusedSettingsField, setFocusedSettingsField] = useState('')
  const [clientType, setClientType] = useState(RENTER_CLIENT_TYPE)
  const [activeTab, setActiveTab] = useState(TABS.OVERVIEW)

  const setFocusFieldAndNavigateToSettings = fieldName => {
    setFocusedSettingsField(fieldName)
    setActiveTab(TABS.SETTINGS)
  }

  const value = {
    address,
    listingPrice,
    marketTempSliderPrice,
    setMarketTempSliderPrice,
    thumbDirection,
    setThumbDirection,
    includeRental,
    setIncludeRental,
    focusedSettingsField,
    setFocusedSettingsField,
    activeTab,
    setActiveTab,
    setFocusFieldAndNavigateToSettings,
    appreciationSliderPercent,
    setAppreciationSliderPercent,
    devMode,
    clientType,
    setClientType,
    widgetMode,
    customerPublicKey,
    customerProfileId,
    clientAuthToken,
  }

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

AppContextProvider.defaultProps = {
  devMode: false,
  zillowUrl: null,
}

AppContextProvider.propTypes = {
  address: PropTypes.string,
  listingPrice: PropTypes.number,
  widgetMode: PropTypes.string,
  devMode: PropTypes.bool,
  zillowUrl: PropTypes.string,
  clientAuthToken: PropTypes.string,
  customerPublicKey: PropTypes.string,
  customerProfileId: PropTypes.string,
  children: PropTypes.any,
}
